import { cn } from '@repo/tailwind-config/tailwind.functions'
import Button from '@repo/ui/button'

import LogItem from './log-item'

export type CommentType = {
  comment: string
  updatedAt: Date
}

type Props = {
  className?: string
  data: CommentType[]
  isLoading?: boolean
  cancelText?: string
  logItemClassName?: string
  dateFormatter: (date: Date) => string
  handleReset?: () => void
}

export const LogSection = ({
  className,
  data,
  cancelText = 'Cancel',
  logItemClassName,
  dateFormatter,
  handleReset
}: Props) => {
  return (
    <div>
      <div className={cn('flex flex-col gap-2', className)}>
        {data?.map((data, index) => (
          <LogItem
            className={logItemClassName}
            key={index}
            comment={data.comment}
            date={data.updatedAt}
            index={index + 1}
            dateFormatter={dateFormatter}
          />
        ))}
      </div>

      {handleReset && (
        <div
          className={'flex justify-end w-full gap-3 pt-5 border-t border-t-white-active p-5 mt-5'}
        >
          <Button
            variant="ghost"
            type="button"
            label={cancelText}
            aria-label={cancelText}
            onClick={handleReset}
          />
        </div>
      )}
    </div>
  )
}
